import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './footer.css'
import facebook from '../../images/facebook.webp'
function Footer() {
  return (
    <div className="Cont">
      <div className='containerFooter'>
        <a href='https://www.facebook.com/doncapital123'>
          <img src={facebook} className='facebook' />
        </a>
        <div>
          <div>
            Copyright © 2024
          </div>
          <a href='tel:+37441080808' className='phone'>
            +374 41 08 08 08
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;